function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import '@/config';
import InitializeI18n from '@/components/initializeI-18n/InitializeI18n';
import PageHead from '@/components/page-head/PageHead';
import PageStyles from '@/components/page-styles/PageStyles';
import { LoginFormStaticProps } from '@/modules/login-form/LoginForm.props';
import { useParamProps } from '@/props/index';
import { safeBooleanProps } from '@/utils/safeBooleanPropsUtil';
import dynamic from 'next/dynamic';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DynamicLoginForm = dynamic(function () {
  return import('@/modules/login-form/LoginForm');
}, {
  ssr: false
});
var DynamicLoginFormPage = function DynamicLoginFormPage(staticProps) {
  var paramProps = useParamProps();
  var props = _objectSpread(_objectSpread({}, staticProps), paramProps);
  safeBooleanProps(props, ['blockEnabled', 'canUserChangePassword', 'isPubo']);
  return /*#__PURE__*/_jsx(React.StrictMode, {
    children: /*#__PURE__*/_jsxs(InitializeI18n, {
      children: [/*#__PURE__*/_jsx(PageHead, {}), /*#__PURE__*/_jsx(PageStyles, {}), /*#__PURE__*/_jsx(DynamicLoginForm, _objectSpread({}, props))]
    })
  });
};
export default DynamicLoginFormPage;
export var getStaticProps = function getStaticProps() {
  return {
    props: LoginFormStaticProps[process.env.NODE_ENV]
  };
};